import { forwardRef, ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { children, className = '', hover = false },
  ref
) {
  return (
    <div
      ref={ref}
      className={`
        bg-white border border-gray-200 rounded-lg p-6 shadow-sm
        ${hover ? 'hover:shadow-md transition-shadow duration-150' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
});

export default Card;

